module.exports = "<app-staff-list></app-staff-list>\r\n"